import { type FunctionComponent } from "react";
import { SkeletonLoader, Tag } from "@kanda-libs/ks-design-library";
import { getColor } from "components/payment/PaymentInfoBanner/PaymentMethod/helpers";
import { useSelector } from "react-redux";
import { selectors } from "store";
import paymentSelectors from "store/selectors/payments";

const PaymentMethod: FunctionComponent = function () {
  const isLoading = useSelector(selectors.getIsLoading);
  const payment = useSelector(paymentSelectors.getFormattedPayment);

  return (
    <SkeletonLoader
      width={60}
      height={20}
      isLoading={isLoading}
      wrapperClassName="mr-6"
      afterLoading={
        <Tag
          color={getColor(payment?.method)}
          size={28}
          variant="solid"
          className="md:mb-0 md:mr-6"
          label={payment?.method}
        />
      }
    />
  );
};

export default PaymentMethod;
